import React from 'react'
import classes from './styles.module.scss';
import Card from '../../../../components/card/card.component';
import { useTranslation } from 'react-i18next';
import { formatDate } from '../../../home/components/left-menu/akim.component';
import { useKato } from '../../../../contexts/kato.context';
import { useShared } from '../../../../contexts/shared.context';
import { ICardName } from '../../../../types/kato.types';
import { useNavigate, useParams } from 'react-router-dom';
import {
    BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
    CartesianGrid,
    LabelList
} from 'recharts';

const translationKey = 'cards.psd-card'

const PsdCard = () => {
    const { t } = useTranslation();
    const { projectEstimateDocumentation } = useKato().katoGeneralInfo
    const { setFullscreen } = useShared();
    const navigate = useNavigate();
    const { kato, link, tab } = useParams<{ kato: string, link: string, tab: string }>();

    if (!projectEstimateDocumentation || projectEstimateDocumentation.length === 0) return null;

    const onClick = () => {
        setFullscreen({ open: true, type: ICardName.PSD });
        navigate(`/${kato}/${link}/${tab}/${ICardName.PSD}`);
    }

    const data = projectEstimateDocumentation.slice(0, 6).map((item: any) => ({
        category: item.category,
        government: item.governmentInvestorsCount,
        quasiGovernment: item.quasiGovernmentInvestorsCount,
        totalCount: item.governmentInvestorsCount + item.quasiGovernmentInvestorsCount
    }))

    return (
        <Card
            title={t(`${translationKey}.title`)}
            subtitle={t(`${translationKey}.subtitle`, { date: formatDate(new Date().toString()) })}
            onClick={onClick}
        >
            <div className={classes['psd-card']}>
                <ResponsiveContainer width="100%" height={data.length * 40}>
                    <BarChart
                        layout="vertical"
                        data={data}
                        margin={{ top: 15, right: 15, left: 15, bottom: 0 }}
                        barSize={10}
                    >
                        <CartesianGrid strokeDasharray="4 4" />
                        <XAxis type="number" tick={{ fontSize: '0.75rem', fontWeight: 400, fill: '#202224' }} axisLine={{
                            stroke: '#DBDCE0',
                            strokeWidth: 1
                        }} />
                        <YAxis type="category" dataKey="category" tick={({ x, y, payload }) => (
                            <text
                                x={5}
                                y={y}
                                textAnchor="start"
                                dominantBaseline="middle"
                                fontSize={'0.75rem'}
                                fontWeight={400}
                                fill="#202224"
                            >
                                {payload.value.length > 30
                                    ? payload.value.slice(0, 27) + '...'
                                    : payload.value}
                            </text>
                        )}
                            axisLine={false}
                            tickLine={false}
                        />
                        <Tooltip />
                        <Bar dataKey="government" stackId="a" fill="#92D050" name={t(`${translationKey}.government`)} radius={[0, 2, 2, 0]} />
                        <Bar dataKey="quasiGovernment" stackId="a" fill="#6968FD" name={t(`${translationKey}.quasiGovernment`)} radius={[0, 2, 2, 0]}>
                            <LabelList
                                dataKey="totalCount"
                                position="right"
                                style={{ fill: 'var(--color-primary)', fontSize: '0.875rem', fontWeight: 700 }}
                            />
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </Card>
    )
}

export default PsdCard